
// this file is automatically generated by git.version.ts script
export const versions = {
  version: '2.4.0.5',
  revision: '887463b7b2a6341bbf35ccaad09e78db1f27f341',
  branch: 'bugfix',
  channel: undefined,
  envTarget: undefined,
};